import { Component, Input, EventEmitter, Output, OnChanges, OnDestroy, SimpleChanges } from '@angular/core';
import { ColorSchemes } from 'src/styles/color-scheme.type';
import { FileInStorageHlp } from '../../helpers/file.helper';
import { FileData, FileInStorageData } from '../../models/file.data';
import { FireStorageService } from '../../services/storage.service';

@Component({
  selector: 'app-attachment-list-in-form',
  templateUrl: './attachment-list-in-form.component.html',
  styleUrls: ['./attachment-list-in-form.component.scss']
})
export class AttachmentListInFormComponent implements OnChanges, OnDestroy {
  @Input() fileList: FileData[] = [];
  @Input() structList: FileInStorageData[] = [];
  @Input() showNewText: boolean = true;
  @Input() showFileSize: boolean = false;
  @Input() disabled: boolean = false;
  @Input() colors: ColorSchemes = ColorSchemes.PRIMARY;
  @Output() onDelete = new EventEmitter<number>();

  public structListWithSize: FileInStorageData[] = [];
  private readonly localFileUrls = new Map<File, string>();

  ColorSchemes = ColorSchemes;
  constructor(private storageService: FireStorageService) {}

  async ngOnChanges(changes: SimpleChanges): Promise<void> {
    if (changes.fileList) this.revokeUnusedLocalFileUrls();

    if (changes.structList && this.showFileSize) {
      this.structListWithSize = await FileInStorageHlp.copyAndAppendFiles(
        changes.structList.currentValue,
        this.structListWithSize,
        this.storageService
      );
    }
  }

  ngOnDestroy(): void {
    this.localFileUrls.forEach((url) => URL.revokeObjectURL(url));
    this.localFileUrls.clear();
  }

  getLocalFileUrl(attachment: FileData): string | null {
    if (!attachment.file) return null;

    let url = this.localFileUrls.get(attachment.file);
    if (!url) {
      url = URL.createObjectURL(attachment.file);
      this.localFileUrls.set(attachment.file, url);
    }
    return url;
  }

  private revokeUnusedLocalFileUrls(): void {
    const currentFiles = new Set(this.fileList.map((attachment) => attachment.file).filter((file): file is File => !!file));
    this.localFileUrls.forEach((url, file) => {
      if (currentFiles.has(file)) return;

      URL.revokeObjectURL(url);
      this.localFileUrls.delete(file);
    });
  }
}
